<template>
    <div class="counter">
        <div class="counter__heading">Vaše skóre</div>
        <div class="counter__inner">
            <img :src="icon" class="counter__icon" alt="ikona">
            <div class="counter__info">
                <div class="counter__number">
                    <ICountUp :endVal="number" :options="{duration: .5, separator: ' '}"></ICountUp>
                </div>
                <div class="counter__text">litrů za den</div>
            </div>
        </div>
    </div>
</template>

<script>
import '@/assets/drop.svg';
import ICountUp from 'vue-countup-v2';

export default {
    name: "GroheCounter",
    components: {
        ICountUp
    },
    props: {
        number: {
            required: true,
            type: Number
        }
    },
    data: () => ({
        icon: require("@/assets/drop.svg")
    })
}
</script>

<style lang="scss">
    .counter {
        display: none;
        position: absolute;
        top: 40px;
        left: 40px;
        &__inner {
            display: flex;
            padding: 20px 30px;
            background-color: $calcareous-sinter;
            border-radius: 5px;
            align-items: center;
        }
        &__heading {
            font-size: 16px;
            text-align: left;
            margin-bottom: 1em;
        }
        &__icon {
            width: 34px;
            margin-right: 20px;
        }
        &__number {
            font-family: Object Sans, sans-serif;
            font-size: 34px;
            margin-bottom: 3px;
            margin-top: 10px;
            line-height: 0.8;
        }
        &__info {
            text-align: left;
        }
        &__text {
            font-size: 16px;
        }

        @media screen and (min-width: $mq-lg) {
            display: block;
        }
    }
</style>
